import { render } from "./CourseDiscuss.vue?vue&type=template&id=6cdd94e2&scoped=true"
import script from "./CourseDiscuss.vue?vue&type=script&lang=js"
export * from "./CourseDiscuss.vue?vue&type=script&lang=js"

import "./CourseDiscuss.vue?vue&type=style&index=0&id=6cdd94e2&scoped=true&lang=css"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdd94e2"]])

export default __exports__